import { ScaledLine3D } from './ScaledLine3D'
import { useSurfaceLines } from '../surfaces/util/useSurfaceLines'
import React from 'react'
import { GeckoComponentPath } from 'types'

/**
 * Surface Line component that places a Scaled Line based on the points passed in.
 *
 * @param points the points to draw the line between
 */

export const SurfaceLine3D: React.FC<{
  path: GeckoComponentPath
}> = ({ path }) => {
  //this component mainly exists so we can run this hook on each of the gecko coords
  const pathCoords = useSurfaceLines([path])
  return pathCoords === undefined || pathCoords.xyzs.length === 0 ? null : (
    <ScaledLine3D points={pathCoords.xyzs} />
  )
}
